import { useCallback, useContext, useEffect, useState } from 'react';
import { ProjectsContext } from 'src/projects/ProjectsContext.ts';
import { Selection } from 'src/projects/types/Selection';
import { SelectionRepository } from 'src/projects/SelectionRepository.ts';
import { Project } from 'src/projects/types/Project';

type DefaultProjectState = {
    selectionRepository: SelectionRepository;
    persistCallback: (selections: Selection[]) => Promise<null>;
}

export const useDefaultProject = () => {
    const projectsRepository = useContext(ProjectsContext)();
    const [state, setState] = useState<DefaultProjectState>({
        selectionRepository: new SelectionRepository([]),
        persistCallback: async () => null,
    });
    const [loading, setLoading] = useState<boolean>(true);
    const updateState = useCallback((p: Project) => {
        setState({
            selectionRepository: new SelectionRepository(p.selections),
            persistCallback: async (selections: Selection[]) => {
                const projectUpdated = {
                    ...p,
                    selections,
                    updatedAt: new Date(),
                };
                await projectsRepository.update(projectUpdated);
                updateState(projectUpdated);
                return null;
            },
        });
    }, [projectsRepository]);

    useEffect(() => {
        setLoading(true);
        projectsRepository.get(projectsRepository.getDefaultProjectName())
            .then((p) => {
                updateState(p);
            }).finally(() => {
                setLoading(false);
            });
    }, [projectsRepository, updateState]);
    return { state, loading };
};
